import { IBalnearioComBanhoLista, IBalnearioSemBanhoLista } from './IBalneario';
import { IOutrasBasesNcmReceber } from './IOutrasBases';

export interface IFatoGerador {
  valor: number;
  rotulo: string;
}

export interface IRetornoListagemBaseCalculo {
  valor: string;
  rotulo: string;
  isHabilitado: boolean;
}

export type PaginasOutrosRegimes =
  | 'balnearioComBanho'
  | 'balnearioSemBanho'
  | 'receitaBruta'
  | 'vendaNacional'
  | 'receitaBrutaCalculada'
  | 'receitaExportacoes';

export type PrimeiraVendaOutrasBases = 'receitaBruta' | 'vendaNacional' | 'receitaExportacoes';

export const NomesPaginasOutrosRegimes: Record<PaginasOutrosRegimes, string> = {
  balnearioComBanho: 'Balneário',
  balnearioSemBanho: 'Balneário',
  receitaBruta: 'Receita Bruta de Vendas (-) Tributos Incidentes',
  vendaNacional: 'Venda no Território Nacional Entre Empresas Coligadas ou do Mesmo Grupo Econômico',
  receitaBrutaCalculada: 'Receita Bruta Calculada',
  receitaExportacoes: 'Receita Calculada - Exportações',
};

export const EndpointsOutrosRegimes: Record<PaginasOutrosRegimes, string> = {
  balnearioComBanho: 'balneario-com-banho',
  balnearioSemBanho: 'balneario-sem-banho',
  receitaBruta: 'receita-bruta-vendas',
  vendaNacional: 'venda-nacional',
  receitaBrutaCalculada: 'receita-bruta-calculada',
  receitaExportacoes: 'receita-calculada-exportacoes',
};

export interface IOutrasBasesCalculo {
  id: number;
  totalBaseDeCalculo: number;
  totalReceita: number;
  totalValorCFEM: number;
  itens: IOutrasBasesNcmReceber[];
}

export interface IBasesCalculoPrimeiraSaidaPorVenda {
  balnearioComBanho: IBalnearioComBanhoLista[] | [];
  balnearioSemBanho: IBalnearioSemBanhoLista[] | [];
  receitaBrutaVendas: IOutrasBasesCalculo[] | [];
  receitaCalculadaExportacoes: IOutrasBasesCalculo[] | [];
  vendaNacional: IOutrasBasesCalculo[] | [];
  valorReceitaTotal: number;
  valorTributosTotal: number;
  valorBaseCalculoTotal: number;
}

export interface IBaseCalculoConsumo {
  receitaBrutaCalculada: IOutrasBasesCalculo[] | [];

  valorReceitaTotal: number;
  valorBaseCalculoTotal: number;
  valorTributosTotal: number;
}

export interface IBaseCalculoTodas {
  primeiraSaidaPorVenda: IBasesCalculoPrimeiraSaidaPorVenda;
  consumo: IBaseCalculoConsumo;
  valorReceitaTotal: number;
  valorTributosTotal: number;
  valorBaseCalculoTotal: number;
  totalValorCfem: number;
}
